import { constant, flow, pipe } from "@effect-ts/core/Function";
import * as O from "@effect-ts/core/Option";
import * as P from "@effect-ts/core/Prelude";
import * as _ from "../Internal/index.mjs";
import { Optional } from "../Internal/index.mjs";
export { Optional }; // -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------

export const id = () => new Optional({
  getOption: O.some,
  set: constant
}); // -------------------------------------------------------------------------------------
// converters
// -------------------------------------------------------------------------------------

/**
 * View a `Optional` as a `Traversal`
 */

export const asTraversal = _.optionalAsTraversal; // -------------------------------------------------------------------------------------
// compositions
// -------------------------------------------------------------------------------------

/**
 * Compose a `Optional` with a `Optional`
 */

export const compose = _.optionalComposeOptional; // -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------

export const modifyOption = _.optionalModifyOption;
export const modify = _.optionalModify;
/**
 * Return an `Optional` from a `Optional` focused on a nullable value
 */

export const fromNullable = /*#__PURE__*/compose( /*#__PURE__*/_.prismAsOptional( /*#__PURE__*/_.prismFromNullable()));
export function filter(predicate) {
  return compose(_.prismAsOptional(_.prismFromPredicate(predicate)));
}
/**
 * Return a `Optional` from a `Optional` and a prop
 */

export const prop = prop => compose(_.lensAsOptional(_.lensProp(prop)(_.lensId())));
/**
 * Return a `Optional` from a `Optional` and a list of props
 */

export const props = (...props) => compose(_.lensAsOptional(_.lensProps(...props)(_.lensId())));
/**
 * Return a `Optional` from a `Optional` and a component
 */

export const component = prop => compose(_.lensAsOptional(_.lensComponent(prop)(_.lensId())));
/**
 * Return a `Optional` from a `Optional` focused on a `ReadonlyArray`
 */

export const index = i => sa => _.optionalComposeOptional(_.indexArray().index(i))(sa);
/**
 * Return a `Optional` from a `Optional` focused on a `ReadonlyRecord` and a key
 */

export const key = key => sa => _.optionalComposeOptional(_.indexRecord().index(key))(sa);
/**
 * Return a `Optional` from a `Optional` focused on a `ReadonlyRecord` and a required key
 */

export const atKey = key => sa => compose(_.lensAsOptional(_.atRecord().at(key)))(sa);
/**
 * Return a `Optional` from a `Optional` focused on the `Some` of a `Option` type
 */

export const some = /*#__PURE__*/compose( /*#__PURE__*/_.prismAsOptional( /*#__PURE__*/_.prismSome()));
/**
 * Return a `Optional` from a `Optional` focused on the `Right` of a `Either` type
 */

export const right = /*#__PURE__*/compose( /*#__PURE__*/_.prismAsOptional( /*#__PURE__*/_.prismRight()));
/**
 * Return a `Optional` from a `Optional` focused on the `Left` of a `Either` type
 */

export const left = /*#__PURE__*/compose( /*#__PURE__*/_.prismAsOptional( /*#__PURE__*/_.prismLeft()));
/**
 * Return a `Traversal` from a `Optional` focused on a `ForEach`
 */

export function forEach(T) {
  return flow(asTraversal, _.traversalComposeTraversal(_.fromForEach(T)()));
}
export const find = /*#__PURE__*/flow(_.find, compose); // -------------------------------------------------------------------------------------
// pipeables
// -------------------------------------------------------------------------------------

export const imap = (f, g) => ea => new Optional({
  getOption: flow(ea.getOption, O.map(f)),
  set: flow(g, ea.set)
}); // -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------

export const OptionalURI = "monocle/Optional";
export const Category = {
  compose,
  id
};
export const Invariant = {
  invmap: ({
    f,
    g
  }) => ({
    f: imap(f, g),
    g: imap(g, f)
  })
};
//# sourceMappingURL=index.mjs.map